// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__c0pE+","inline":"loading_inline__R9lGm","dots":"loading_dots__5sfgl","dotFlashing":"loading_dotFlashing__MQ51N"};